<template>
  <div class="layout-wrapper" id="organization">
    <v-card class="light-card">
        <v-toolbar color="primary" id="toolbar">
          <v-card-title class="top-title">Organization</v-card-title>
          <v-spacer />
          <div class="d-flex align-baseline w-100">
            <div>
              <v-text-field
                v-model="name"
                prepend-inner-icon="search"
                label="Search"
                solo
                class="select-field m-w mt-3"
                single-line
                hide-details
              />
            </div>
            <v-spacer />
            <v-btn class="primary-btn white--text text-style ma-0"
                   depressed
                   @click="$router.push('/organizationeditor/new')"
            >
                Add Organization
            </v-btn>
          </div>
        </v-toolbar>
        <v-list two-line class="light-list py-0">
          <template v-for="organization in filtered_organizations">
            <v-list-item
              :key="organization.entity_id"
              @click="$router.push('/organizationeditor/' + organization.entity_id)">
              <v-list-item-content>
                <v-list-item-title v-html="organization.name"></v-list-item-title>
              </v-list-item-content>
                <v-btn text @click.stop="openAssignUserDialog(organization)" color="primary" class="mr-3">
                    <span class="material-icons mr-2">add</span>
                    Add a member
                </v-btn>
              <v-btn icon @click.stop="openDeleteItemDialog(organization)">
                <v-icon color="#000">delete</v-icon>
              </v-btn>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
      <!--    Confirm Delete dialog-->
      <v-dialog v-model="dialogRemoveItem.open" persistent max-width="650">
          <v-card class="delete-dialog">
              <v-card-title class="headline dark--text">Please confirm</v-card-title>
              <v-card-text class="dark--text">Are you want to delete <strong>{{dialogRemoveItem.name}}</strong>?</v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="cancel-btn" text @click="dialogRemoveItem.open = false">Cancel</v-btn>
                  <v-btn class="save-btn" text @click="apiDelete(dialogRemoveItem.entityId)">Confirm</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <!-- Dialogs -->
      <v-dialog persistent attach v-model="assignUserDialog" max-width="750" id="member-dialog">
          <v-card class="relative add-edit-wrapper">
              <div class="close-btn">
                  <i class="material-icons dark--text" @click="assignUserDialog = false">
                      clear
                  </i>
              </div>
              <v-card-title class="pb-2 headline dark-text justify-center" v-if="assignUserData.organization">{{assignUserData.organization.name}}</v-card-title>
              <v-container grid-list-xl fluid>
                  <div v-if="assignUserData.organization && assignUserData.organization.users && assignUserData.organization.users.length > 0">
                      <p class="dark--text">Add a member</p>
                      <v-form v-model="validAssignUserForm" class="org-assign-user-form">
                          <v-flex md12>
                              <p class="input-label text-style">
                                  Name*
                              </p>
                              <v-text-field
                                      class="select-field"
                                      v-model="assignUserData.name"
                                      required
                                      :rules="nameRules"
                                      solo></v-text-field>
                          </v-flex>
                          <v-flex md12>
                              <p class="input-label text-style">
                                  Email*
                              </p>
                              <v-text-field
                                      class="select-field"
                                      v-model="assignUserData.email"
                                      required
                                      :rules="emailRules"
                                      solo></v-text-field>
                          </v-flex>
                          <v-flex md12>
                              <p class="input-label text-style">
                                  Role*
                              </p>
                              <v-select
                                      class="select-field"
                                      :items="userRoles"
                                      item-text="name"
                                      item-value="value"
                                      v-model="assignUserData.role"
                                      required
                                      :rules="roleRules"
                                      solo
                              ></v-select>
                          </v-flex>
                          <v-card-actions class="d-flex flex-column pa-0 mb-30">
                              <v-spacer></v-spacer>
                              <v-btn
                                      class="save-btn mb-16px"
                                      :disabled="!validAssignUserForm"
                                      @click="assignUser">
                                  Save
                              </v-btn>
                              <v-btn class="cancel-btn" text @click="assignUserDialog = false">Cancel</v-btn>
                          </v-card-actions>
                      </v-form>
                      <p class="dark--text mb-0">Existing members</p>
                      <v-list single-line class="pb-30">
                          <template v-for="(user, index) in assignUserData.organization.users">
                              <v-list-item single-line :key="`${user.user_id}_${index}`">
                                  <v-list-item-content  single-line >
                                      <v-list-item-title v-if="user.name">{{user.name}}</v-list-item-title>
                                      <v-list-item-title v-if="user.email">{{user.email}}</v-list-item-title>
                                      <v-list-item-title v-else> No Email </v-list-item-title>
                                      <v-list-item-title class="d-flex justify-center">{{user.role ? '' + user.role : ''}}</v-list-item-title>
                                  </v-list-item-content>
                              </v-list-item>
                          </template>
                      </v-list>
                  </div>
                  <v-spacer></v-spacer>
              </v-container>
          </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validateEmail } from '@/utils/main_helper'

export default {
  name: 'Organization',
  computed: {
    ...mapGetters(['organizations', 'filtered_organizations'])
  },
  data () {
    return {
      validAssignUserForm: false,
      assignUserData: {},
      assignUserDialog: false,
      userRoles: [
        { name: 'Admin', value: 'admin' },
        { name: 'User', value: 'user' }
      ],
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 100 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => validateEmail(v) || 'E-mail must be valid'
      ],
      roleRules: [
        v => !!v || 'Role is required'
      ],
      name: '',
      dialogRemoveItem: {
        open: false,
        name: '',
        entityId: ''
      }
    }
  },

  created () {
    this.$store.dispatch('loadOrganizations', this.name)
  },

  methods: {
    openDeleteItemDialog (item) {
      this.dialogRemoveItem = {
        open: true,
        entityId: item.entity_id,
        name: item.name
      }
    },
    apiDelete (id) {
      this.$store.dispatch('deleteOrganization', id).then(() => {
        this.resetDialogRemoveItem()
      }).catch(console.error)
    },
    resetDialogRemoveItem () {
      this.dialogRemoveItem = {
        open: false,
        name: '',
        entityId: ''
      }
    },
    openAssignUserDialog (organization) {
      this.assignUserData = {
        organization: organization
      }
      this.assignUserDialog = true
    },
    assignUser () {
      if (!this.assignUserData.organization) {
        this.$notify({
          group: 'loggedIn',
          type: 'error',
          text: 'Invalid Organization'
        })
        return false
      }
      const organization = { ...this.assignUserData.organization }

      if (organization.users === undefined) {
        organization.users = []
      }
      const existMember = organization.users.some(user => user.email === this.assignUserData.email)
      if (existMember) {
        this.$notify({
          group: 'loggedIn',
          type: 'error',
          text: 'The user email already exist'
        })
        return false
      }
      organization.users.push({
        name: this.assignUserData.name,
        role: this.assignUserData.role,
        email: this.assignUserData.email
      })

      this.$store.commit('updateOrganizationData', organization)
      this.$store.dispatch('saveOrganization', organization)
      this.assignUserDialog = false
    }
  },
  watch: {
    name () {
      let filteredOrganizations
      if (this.name) {
        filteredOrganizations = this.filtered_organizations.filter(item => item.name.includes(this.name))
      } else {
        filteredOrganizations = this.organizations
      }
      this.$store.commit('updateFilteredOrganizations', filteredOrganizations)
    }
  }
}
</script>
